<template lang="pug">
    creators-list-modal.followings-modal(v-bind="$attrs" title="Following" :creators="creators" emptyMessage="Following nobody")
</template>

<script>
import UserFollowsService from '../../services/user-follows-service'

export default {
    name: 'followings-modal',

    data() {
        return {
            creators: null,
        }
    },

    created() {
        UserFollowsService.following().then(({data}) => {
            this.creators = data.data
        })
    },
}
</script>
